import { cn } from "@/app/utils/className";

interface MapSpotsProps {
  className?: string;
}

export const MapSpots = ({ className }: MapSpotsProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="629"
      height="553"
      viewBox="0 0 629 553"
      fill="none"
      className={cn(`w-full`, className)}
    >
      <path
        opacity="0.534"
        d="M115 272C133.225 272 148 257.225 148 239C148 220.775 133.225 206 115 206C96.7746 206 82 220.775 82 239C82 257.225 96.7746 272 115 272Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0"
      />
      <path
        opacity="0.534"
        d="M326 238C344.225 238 359 223.225 359 205C359 186.775 344.225 172 326 172C307.775 172 293 186.775 293 205C293 223.225 307.775 238 326 238Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0"
      />
      <path
        opacity="0.534"
        d="M435.848 278C454.073 278 468.848 263.225 468.848 245C468.848 226.775 454.073 212 435.848 212C417.622 212 402.848 226.775 402.848 245C402.848 263.225 417.622 278 435.848 278Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0"
      />
      <path
        opacity="0.534"
        d="M507.848 242C526.073 242 540.848 227.225 540.848 209C540.848 190.775 526.073 176 507.848 176C489.622 176 474.848 190.775 474.848 209C474.848 227.225 489.622 242 507.848 242Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0"
      />
      <path
        opacity="0.534"
        d="M355.848 222C374.073 222 388.848 207.225 388.848 189C388.848 170.775 374.073 156 355.848 156C337.622 156 322.848 170.775 322.848 189C322.848 207.225 337.622 222 355.848 222Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0"
      />
      <path
        opacity="0.534"
        d="M425.848 115C444.073 115 458.848 100.225 458.848 82C458.848 63.7746 444.073 49 425.848 49C407.622 49 392.848 63.7746 392.848 82C392.848 100.225 407.622 115 425.848 115Z"
        fill="#ED8747"
        className="orange-fill-semi-transparent opacity-0 one"
      />

      <path
        d="M115 249C120.523 249 125 244.523 125 239C125 233.477 120.523 229 115 229C109.477 229 105 233.477 105 239C105 244.523 109.477 249 115 249Z"
        fill="#ED8747"
        className="orange-fill satellite"
      />
      <path
        d="M326 215C331.523 215 336 210.523 336 205C336 199.477 331.523 195 326 195C320.477 195 316 199.477 316 205C316 210.523 320.477 215 326 215Z"
        fill="#ED8747"
        className="orange-fill satellite"
      />
      <path
        d="M436 255C441.523 255 446 250.523 446 245C446 239.477 441.523 235 436 235C430.477 235 426 239.477 426 245C426 250.523 430.477 255 436 255Z"
        fill="#ED8747"
        className="orange-fill satellite"
      />
      <path
        d="M508 219C513.523 219 518 214.523 518 209C518 203.477 513.523 199 508 199C502.477 199 498 203.477 498 209C498 214.523 502.477 219 508 219Z"
        fill="#ED8747"
        className="orange-fill satellite"
      />
      <path
        d="M356 199C361.523 199 366 194.523 366 189C366 183.477 361.523 179 356 179C350.477 179 346 183.477 346 189C346 194.523 350.477 199 356 199Z"
        fill="#ED8747"
        className="orange-fill satellite"
      />
      <path
        d="M426 92C431.523 92 436 87.5228 436 82C436 76.4772 431.523 72 426 72C420.477 72 416 76.4772 416 82C416 87.5228 420.477 92 426 92Z"
        fill="#ED8747"
        className="orange-fill manual"
      />

      <path
        d="M415.762 195.752C421.285 195.752 425.762 191.275 425.762 185.752C425.762 180.229 421.285 175.752 415.762 175.752C410.239 175.752 405.762 180.229 405.762 185.752C405.762 191.275 410.239 195.752 415.762 195.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M405.762 228.752C411.285 228.752 415.762 224.275 415.762 218.752C415.762 213.229 411.285 208.752 405.762 208.752C400.239 208.752 395.762 213.229 395.762 218.752C395.762 224.275 400.239 228.752 405.762 228.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M375.762 244.752C381.285 244.752 385.762 240.275 385.762 234.752C385.762 229.229 381.285 224.752 375.762 224.752C370.239 224.752 365.762 229.229 365.762 234.752C365.762 240.275 370.239 244.752 375.762 244.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M445.762 295.752C451.285 295.752 455.762 291.275 455.762 285.752C455.762 280.229 451.285 275.752 445.762 275.752C440.239 275.752 435.762 280.229 435.762 285.752C435.762 291.275 440.239 295.752 445.762 295.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M487.762 284.752C493.285 284.752 497.762 280.275 497.762 274.752C497.762 269.229 493.285 264.752 487.762 264.752C482.239 264.752 477.762 269.229 477.762 274.752C477.762 280.275 482.239 284.752 487.762 284.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M220.762 264.752C226.285 264.752 230.762 260.275 230.762 254.752C230.762 249.229 226.285 244.752 220.762 244.752C215.239 244.752 210.762 249.229 210.762 254.752C210.762 260.275 215.239 264.752 220.762 264.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M200.762 285.752C206.285 285.752 210.762 281.275 210.762 275.752C210.762 270.229 206.285 265.752 200.762 265.752C195.239 265.752 190.762 270.229 190.762 275.752C190.762 281.275 195.239 285.752 200.762 285.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M403.762 313.752C409.285 313.752 413.762 309.275 413.762 303.752C413.762 298.229 409.285 293.752 403.762 293.752C398.239 293.752 393.762 298.229 393.762 303.752C393.762 309.275 398.239 313.752 403.762 313.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M425.762 360.752C431.285 360.752 435.762 356.275 435.762 350.752C435.762 345.229 431.285 340.752 425.762 340.752C420.239 340.752 415.762 345.229 415.762 350.752C415.762 356.275 420.239 360.752 425.762 360.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M302.762 254.752C308.285 254.752 312.762 250.275 312.762 244.752C312.762 239.229 308.285 234.752 302.762 234.752C297.239 234.752 292.762 239.229 292.762 244.752C292.762 250.275 297.239 254.752 302.762 254.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M292.762 313.752C298.285 313.752 302.762 309.275 302.762 303.752C302.762 298.229 298.285 293.752 292.762 293.752C287.239 293.752 282.762 298.229 282.762 303.752C282.762 309.275 287.239 313.752 292.762 313.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M158.762 340.752C164.285 340.752 168.762 336.275 168.762 330.752C168.762 325.229 164.285 320.752 158.762 320.752C153.239 320.752 148.762 325.229 148.762 330.752C148.762 336.275 153.239 340.752 158.762 340.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M385.762 350.752C391.285 350.752 395.762 346.275 395.762 340.752C395.762 335.229 391.285 330.752 385.762 330.752C380.239 330.752 375.762 335.229 375.762 340.752C375.762 346.275 380.239 350.752 385.762 350.752Z"
        fill="#27F49D"
        className="green-dot manual"
      />
      <path
        d="M262.762 244.752C268.285 244.752 272.762 240.275 272.762 234.752C272.762 229.229 268.285 224.752 262.762 224.752C257.239 224.752 252.762 229.229 252.762 234.752C252.762 240.275 257.239 244.752 262.762 244.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M118.762 330.752C124.285 330.752 128.762 326.275 128.762 320.752C128.762 315.229 124.285 310.752 118.762 310.752C113.239 310.752 108.762 315.229 108.762 320.752C108.762 326.275 113.239 330.752 118.762 330.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M345.762 340.752C351.285 340.752 355.762 336.275 355.762 330.752C355.762 325.229 351.285 320.752 345.762 320.752C340.239 320.752 335.762 325.229 335.762 330.752C335.762 336.275 340.239 340.752 345.762 340.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M222.762 234.752C228.285 234.752 232.762 230.275 232.762 224.752C232.762 219.229 228.285 214.752 222.762 214.752C217.239 214.752 212.762 219.229 212.762 224.752C212.762 230.275 217.239 234.752 222.762 234.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M78.7617 320.752C84.2846 320.752 88.7617 316.275 88.7617 310.752C88.7617 305.229 84.2846 300.752 78.7617 300.752C73.2389 300.752 68.7617 305.229 68.7617 310.752C68.7617 316.275 73.2389 320.752 78.7617 320.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M323.762 396.752C329.285 396.752 333.762 392.275 333.762 386.752C333.762 381.229 329.285 376.752 323.762 376.752C318.239 376.752 313.762 381.229 313.762 386.752C313.762 392.275 318.239 396.752 323.762 396.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M313.762 350.752C319.285 350.752 323.762 346.275 323.762 340.752C323.762 335.229 319.285 330.752 313.762 330.752C308.239 330.752 303.762 335.229 303.762 340.752C303.762 346.275 308.239 350.752 313.762 350.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M293.762 386.752C299.285 386.752 303.762 382.275 303.762 376.752C303.762 371.229 299.285 366.752 293.762 366.752C288.239 366.752 283.762 371.229 283.762 376.752C283.762 382.275 288.239 386.752 293.762 386.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M230.762 434.752C236.285 434.752 240.762 430.275 240.762 424.752C240.762 419.229 236.285 414.752 230.762 414.752C225.239 414.752 220.762 419.229 220.762 424.752C220.762 430.275 225.239 434.752 230.762 434.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M365.762 424.752C371.285 424.752 375.762 420.275 375.762 414.752C375.762 409.229 371.285 404.752 365.762 404.752C360.239 404.752 355.762 409.229 355.762 414.752C355.762 420.275 360.239 424.752 365.762 424.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M240.762 370.752C246.285 370.752 250.762 366.275 250.762 360.752C250.762 355.229 246.285 350.752 240.762 350.752C235.239 350.752 230.762 355.229 230.762 360.752C230.762 366.275 235.239 370.752 240.762 370.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M260.762 303.752C266.285 303.752 270.762 299.275 270.762 293.752C270.762 288.229 266.285 283.752 260.762 283.752C255.239 283.752 250.762 288.229 250.762 293.752C250.762 299.275 255.239 303.752 260.762 303.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M275.762 141.752C281.285 141.752 285.762 137.275 285.762 131.752C285.762 126.229 281.285 121.752 275.762 121.752C270.239 121.752 265.762 126.229 265.762 131.752C265.762 137.275 270.239 141.752 275.762 141.752Z"
        fill="#27F49D"
        className="green-dot manual"
      />
      <path
        d="M343.762 142.752C349.285 142.752 353.762 138.275 353.762 132.752C353.762 127.229 349.285 122.752 343.762 122.752C338.239 122.752 333.762 127.229 333.762 132.752C333.762 138.275 338.239 142.752 343.762 142.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M364.762 178.752C370.285 178.752 374.762 174.275 374.762 168.752C374.762 163.229 370.285 158.752 364.762 158.752C359.239 158.752 354.762 163.229 354.762 168.752C354.762 174.275 359.239 178.752 364.762 178.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M80.7617 178.752C86.2846 178.752 90.7617 174.275 90.7617 168.752C90.7617 163.229 86.2846 158.752 80.7617 158.752C75.2389 158.752 70.7617 163.229 70.7617 168.752C70.7617 174.275 75.2389 178.752 80.7617 178.752Z"
        fill="#27F49D"
        className="green-dot manual"
      />
      <path
        d="M134.762 121.752C140.285 121.752 144.762 117.275 144.762 111.752C144.762 106.229 140.285 101.752 134.762 101.752C129.239 101.752 124.762 106.229 124.762 111.752C124.762 117.275 129.239 121.752 134.762 121.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M190.762 179.752C196.285 179.752 200.762 175.275 200.762 169.752C200.762 164.229 196.285 159.752 190.762 159.752C185.239 159.752 180.762 164.229 180.762 169.752C180.762 175.275 185.239 179.752 190.762 179.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M157.762 208.752C163.285 208.752 167.762 204.275 167.762 198.752C167.762 193.229 163.285 188.752 157.762 188.752C152.239 188.752 147.762 193.229 147.762 198.752C147.762 204.275 152.239 208.752 157.762 208.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M167.762 254.752C173.285 254.752 177.762 250.275 177.762 244.752C177.762 239.229 173.285 234.752 167.762 234.752C162.239 234.752 157.762 239.229 157.762 244.752C157.762 250.275 162.239 254.752 167.762 254.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M70.7617 274.752C76.2846 274.752 80.7617 270.275 80.7617 264.752C80.7617 259.229 76.2846 254.752 70.7617 254.752C65.2389 254.752 60.7617 259.229 60.7617 264.752C60.7617 270.275 65.2389 274.752 70.7617 274.752Z"
        fill="#27F49D"
        className="green-dot satellite"
      />
      <path
        d="M512.967 312.6C515.034 310.8 519.547 312 519.717 308.233C520.164 298.314 528.508 292.341 531.594 283.502C534.232 275.946 539.835 267.851 550.375 267.73C551.404 267.74 552.414 267.446 553.277 266.883C554.139 266.321 554.816 265.515 555.222 264.569C556.786 259.997 560.86 257.444 563.138 253.817C566.138 249.043 571.489 249.849 574.794 246.45C571.127 243.222 574.894 239.892 574.917 236.577C574.951 231.627 571.086 226.427 575.839 221.527C578.065 219.233 578.412 215.527 582.12 214.02C585.941 212.466 586.774 207.983 588.18 204.699C590.233 199.905 589.565 193.939 594.638 190.462C591.977 186 596.654 182.286 595.904 177.996C595.427 175.271 596.399 172.855 597.74 170.513C600.758 165.246 602.134 159.75 598.318 154.363C595.995 151.084 597.017 147.571 597.305 144.363C597.805 138.878 598.649 133.206 600.966 128.189C607.666 113.673 610.259 98.103 613.266 82.642C614.22 77.742 616.247 72.691 613.359 67.686C613.264 67.4995 613.213 67.2928 613.213 67.083C613.213 66.8732 613.264 66.6665 613.359 66.48C619.286 60.597 617.188 50.837 623.867 45.189C627.594 42.037 628.185 31.678 625.854 27.168C624.989 25.5592 624.482 23.7826 624.368 21.9597C624.254 20.1368 624.536 18.3109 625.193 16.607C626.511 13.118 625.315 9.507 625.839 6.013C626.314 2.841 622.59 4.232 622.094 1C618.262 5.412 614.361 8.276 608.967 7.261C607.695 7.022 606.392 7.252 605.888 8.514C604.188 12.767 600.681 12.328 597.122 12.286C593.356 12.242 589.274 9.412 585.846 13.438C585.433 13.923 585.914 13.795 585.308 13.433C581.219 10.993 576.245 10.961 571.034 8.844C565.612 17.756 552.265 15.367 545.497 24.329C551.012 35.754 551.18 41.147 545.997 44.021C540.097 47.297 536.457 47.115 533.526 43.395C529.4 44.195 524.963 46.167 523.893 49.731C522.658 53.845 519.167 55.281 517.833 58.594C512.566 57.554 512.477 52.868 512.633 50.271C512.994 44.44 509.354 42.818 505.461 40.922C502.914 39.682 498.952 40.069 499.79 35.284C500.032 33.905 498.277 33.946 497.442 33.324C491.109 28.606 484.097 28.671 476.785 29.645C472.552 30.209 469.02 29.214 466.085 25.411C462.378 20.611 457.036 24.126 453.176 25.021C442.19 27.567 440.23 27.997 427.494 24.894C425.819 24.486 422.589 25.161 421.383 27.239C417.754 33.493 410.227 34.554 405.507 39.453C404.279 40.726 403.214 41.446 402.431 43.326C401.695 45.2929 400.343 46.9694 398.577 48.1059C396.811 49.2424 394.726 49.778 392.631 49.633C391.801 49.608 390.969 49.633 390.137 49.633C262.745 49.633 135.353 49.6427 7.96151 49.662C5.88551 49.662 3.71651 49.162 1.58151 50.112C0.630512 52.245 1.13251 54.412 1.13151 56.488C1.09818 148.299 1.08851 240.111 1.10251 331.923C1.10251 340.629 1.28851 340.038 9.77151 342.705C16.4505 344.805 23.5585 346.466 29.1855 351.52C32.5485 346.332 36.3705 342.683 42.8985 346.208C43.7006 346.454 44.5566 346.465 45.3645 346.238C55.0515 344.779 59.6245 346.667 64.0265 354.38C65.5991 356.973 68.0993 358.87 71.0195 359.686C69.3785 364.635 67.8615 369.32 72.8045 373.041C75.3245 374.941 74.8595 378.378 76.9715 380.701C78.0655 381.901 76.7645 385.957 80.2005 384.675C82.4005 383.853 86.1475 383.261 85.8865 379.281C85.7195 376.726 86.6135 374.789 89.7125 373.104C94.5385 378.578 101.252 379.437 108.313 380.135C111.829 380.482 114.313 384.404 117.628 386.243C118.881 386.943 118.851 389.406 118.207 390.432C115.246 395.15 117.819 399.74 118.53 404.172C119.03 407.291 120.777 410.938 125.17 411.043C128.537 411.124 130.099 413.011 129.445 416.028C128.572 420.062 131.507 421.474 133.935 422.144C143.751 424.853 151.062 431.177 158.211 437.859C160.281 439.974 162.597 441.834 165.111 443.397C166.811 444.35 168.483 445.61 168.697 447.22C169.533 453.5 175.202 456.233 178.264 460.848C180.622 464.403 185.913 463.907 188.186 467.082C192.544 467.556 193.322 460.464 197.625 464C199.447 461.176 196.335 459.861 197.277 457.1C199.505 450.574 204.658 447.2 212.377 449.918C215.953 451.175 219.007 451.205 221.729 449.567C225.401 447.356 228.229 448.319 230.462 451.003C234.304 455.622 238.693 458.214 244.88 457.203C247.9 456.711 250.42 459.103 252.797 460.097C257.303 461.984 261.907 460.171 266.097 462.106C266.375 462.237 266.678 462.309 266.986 462.319C267.294 462.329 267.601 462.275 267.887 462.162C268.174 462.048 268.434 461.878 268.652 461.66C268.87 461.442 269.042 461.182 269.156 460.896C271.699 454.368 277.405 457.673 280.272 458.782C286.464 461.182 291.654 465.928 299.141 464.81H299.153C301.063 464.671 302.898 464.003 304.453 462.883C306.517 461.49 309.185 462.175 311.579 462.221C314.235 462.272 316.374 462.351 317.259 459.058C318.185 455.616 321.359 455.165 324.013 456.034C329.677 457.89 329.595 458.134 334.026 454.675C335.026 454.521 335.226 455.784 335.901 455.884C350.201 458.023 350.256 470.216 352.266 480.319C352.654 482.269 352.466 484.193 353.966 485.84C356.875 489.017 356.666 493.532 358.799 497.146C359.974 499.146 358.447 501.446 356.585 503.397C354.893 505.175 355.693 507.331 358.333 508.274C371.887 513.12 384.142 520.653 397.014 526.911C413.229 534.795 429.101 543.379 446.228 551.416C446.252 547.764 446.108 544.833 446.287 541.916C446.408 539.943 445.346 538.105 447.926 536.069C450.749 533.843 448.577 529.963 443.126 526.334C442.607 524.184 444.905 523.104 444.236 519.997C442.541 512.122 446.903 504.539 449.59 497.13C450.566 494.722 451.118 492.164 451.222 489.568C451.246 487.699 450.454 485.229 451.36 484.068C453.173 481.82 454.387 479.149 454.885 476.304C455.384 473.459 455.152 470.534 454.211 467.803C452.599 462.603 458.804 458.586 455.701 453.364C455.286 452.664 456.119 450.871 457.466 450.327C461.552 448.677 459.715 446.003 458.536 443.721C459.893 441.321 462.702 441.899 464.128 438.665C466.618 433.018 467.969 426.71 471.807 421.655C473.153 419.882 471.595 417.596 472.516 416.098C475.16 411.798 478.145 407.613 484.23 408.773C485.293 402.985 489.205 397.628 484.997 391.664C483.897 390.111 485.683 387.854 486.847 386.852C492.117 382.318 491.407 376.88 490.273 370.579C491.552 369.352 494.126 368.224 493.662 364.936C492.653 357.769 497.089 353.108 501.775 348.795C503.909 346.832 507.013 345.745 505.608 341.834C505.526 341.605 505.659 339.763 506.133 339.464C514.922 333.928 511.257 323.776 514.753 316.306C514.838 316.125 513.984 315.506 513.568 315.089"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="nsw-border-path"
      />
    </svg>
  );
};
